<template>
  <v-app style="overflow-x: hidden;">
    <v-navigation-drawer app v-model="drawer" :temporary="isDrawerVisible" v-if="isDrawerVisible" class="modern-drawer">
      <v-list class="pt-0">
        <v-list-item-title style="color: #365136;padding-top:12px; text-align: center; font-weight: 1000; font-size: 18px;">W O R K D E S K</v-list-item-title>
        <hr style="margin: 10px auto; width: 70%; border-color: #f0f5f0;">
        <v-list-item v-for="(item, index) in items" :key="index" link :class="{ 'active': item.id === activeSection }" :to="item.id != 'logIn' ? item.to : ''" @click="scrollToSection(item.id, item.to)">
          <v-list-item-title style="text-align: center;" :class="{ 'active-tab': item.id === activeSection }">
            <p class="text-style">{{ item.text }}</p>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar  class="d-flex justify-start align-start pt-0" app style="background-color: #365136;" v-if="isDrawerVisible">
  <v-btn
    style="align-self: end; justify-self:center; background-color: transparent;"
    icon
    @click.stop="drawer = !drawer"
    v-if="isDrawerVisible"
  >
    <v-icon color="white">mdi-menu</v-icon>
  </v-btn>
  <v-toolbar-title style="align-self: flex-end;" class="white--text my-auto">
    <p class="title-style2">Workdesk</p>
  </v-toolbar-title>
</v-app-bar>

    <v-tabs v-if="!isDrawerVisible" centered background-color="#365136" class="text-center custom-tabs">
      <v-tab class="white--text" v-for="(item, index) in items" :key="index" @click="scrollToSection(item.id, item.to)" :class="{ 'active-tab': item.id === activeSection }">
        <p class="title-style">{{ item.text }}</p>
      </v-tab>
    </v-tabs>

    <router-view/>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
      items: [
        { id: 'home', text: 'Home', to: '/#home' },
        { id: 'features', text: 'Features', to: '/#features' },
        { id: 'whyus', text: 'Why Us?', to: '/#whyus' },
        { id: 'packages', text: 'Packages', to: '/#packages' },
        { id: 'contactUs', text: 'Contact Us', to: '/#contactUs' },
        { id: 'supportApp', text: 'Download', to: '/#supportApp' },
        { id: 'logIn', text: 'Log In', to: 'https://portal.csiworkdesk.com/' }
      ],
      activeSection: null
    };
  },
  computed: {
    isDrawerVisible() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  mounted() {
    this.updateActiveSection();
  },
  watch: {
    '$route'() {
      this.updateActiveSection();
    }
  },
  methods: {
    scrollToSection(sectionId, sectionPath) {
      if (sectionId === 'logIn'){ // if login is clicked. redirect to ipms retail subscription
        window.open(sectionPath); // if you want new tab without closing the original
        // window.location.href = sectionPath // for same tab
      } else {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
        this.drawer = false;
      }
    },
    updateActiveSection() {
      const hash = this.$route.hash.substr(1); // Remove the '#' from the hash
      this.activeSection = hash !== '' ? hash : null;
    }
  }
};
</script>

<style scoped>
.title-style{
  font-family: 'Poppins', sans-serif;
  margin: 0px;
  font-size: 15px;
}
.title-style2{
  font-family: 'Poppins', sans-serif;
  margin: 0px;
  font-size: 20px;
}
.text-style{
  font-family: 'Poppins', sans-serif;
  margin: 0px;
  font-size: 15px;
}
.v-tabs {
  box-sizing: border-box;
  position: fixed;
  z-index: 20;
}

.modern-drawer {
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  font-weight: bold;
  color: #27272a;
}

.active-tab {
  color: white;
  
}

.active {
  background-color:#f0f5f0 ;

}

@media (max-width: 768px) {
.active-tab {
  color: #808766; 


}
}
</style>
